<ul class="nav nav-tabs nav-pill d-flex text-center styleguide-tabs">
    <li *ngFor="let item of variablesTabs"
        class="nav-item">
        <a class="nav-link {{item.isActive ? 'active' : ''}}"
           routerLink="{{item.link}}">
            {{item.translation | translate}}
        </a>
    </li>
</ul>